module.exports = __webpack_public_path__ + "static/media/CentraNo2-Bold.1cb0f869.woff2";